import { useState, useEffect } from 'react';
import Layout from '../components/Layout';

const C = {
  ink: '#0B0E17', surface: '#1E2235', border: '#2A2E45',
  muted: '#8892A4', gold: '#F0B429', teal: '#00C9B1',
  coral: '#FF6B6B', text: '#E8EDF5', sub: '#C5CDD8',
};

const STYLES = `
  .br-page { padding: 32px; max-width: 1100px; margin: 0 auto; font-family: 'Cabinet Grotesk', sans-serif; }
  .br-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 32px; flex-wrap: wrap; }
  .br-title { font-size: 1.55rem; font-weight: 800; color: ${C.text}; margin: 0; letter-spacing: -0.3px; }
  .br-sub { font-size: 0.84rem; color: ${C.muted}; margin: 4px 0 0; }
  .br-btn-primary { background: ${C.gold}; color: ${C.ink}; border: none; border-radius: 10px; padding: 10px 18px; font-size: 0.85rem; font-weight: 700; cursor: pointer; transition: opacity 150ms; font-family: inherit; white-space: nowrap; }
  .br-btn-primary:hover { opacity: 0.88; }
  .br-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
  .br-wrap { background: ${C.surface}; border: 1px solid ${C.border}; border-radius: 16px; overflow: hidden; }
  .br-table { width: 100%; border-collapse: collapse; }
  .br-table thead th { padding: 12px 16px; font-size: 0.7rem; font-weight: 700; color: ${C.muted}; letter-spacing: 0.06em; text-transform: uppercase; text-align: left; border-bottom: 1px solid ${C.border}; background: rgba(255,255,255,0.02); white-space: nowrap; }
  .br-table tbody tr { border-bottom: 1px solid ${C.border}; transition: background 150ms; }
  .br-table tbody tr:last-child { border-bottom: none; }
  .br-table tbody tr:hover { background: rgba(255,255,255,0.025); }
  .br-td { padding: 14px 16px; font-size: 0.875rem; color: ${C.text}; vertical-align: middle; }
  .br-badge-active { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 0.68rem; font-weight: 700; background: rgba(0,201,177,0.12); color: ${C.teal}; border: 1px solid rgba(0,201,177,0.25); }
  .br-badge-inactive { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 0.68rem; font-weight: 700; background: rgba(136,146,164,0.1); color: ${C.muted}; border: 1px solid rgba(136,146,164,0.2); }
  .br-badge-default { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 0.68rem; font-weight: 700; background: rgba(240,180,41,0.12); color: ${C.gold}; border: 1px solid rgba(240,180,41,0.3); }
  .br-btn-sm { padding: 5px 12px; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer; transition: all 140ms; border: 1px solid ${C.border}; background: rgba(255,255,255,0.05); color: ${C.sub}; font-family: inherit; }
  .br-btn-sm:hover { background: rgba(255,255,255,0.09); color: ${C.text}; }
  .br-btn-danger { border-color: rgba(255,107,107,0.35) !important; color: ${C.coral} !important; background: rgba(255,107,107,0.07) !important; }
  .br-btn-danger:hover { background: rgba(255,107,107,0.14) !important; }
  .br-btn-ghost { background: none; border: none; font-size: 0.72rem; font-weight: 600; color: ${C.muted}; cursor: pointer; font-family: inherit; padding: 0; }
  .br-btn-ghost:hover { color: ${C.gold}; }
  .br-empty { padding: 64px 20px; text-align: center; }
  .br-loading { padding: 44px; text-align: center; color: ${C.muted}; font-size: 0.875rem; }
  .br-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.65); backdrop-filter: blur(4px); z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .br-modal { background: ${C.surface}; border: 1px solid ${C.border}; border-radius: 18px; width: 100%; max-width: 480px; padding: 28px; box-shadow: 0 24px 60px rgba(0,0,0,0.55); }
  .br-modal-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; }
  .br-modal-title { font-size: 1.1rem; font-weight: 800; color: ${C.text}; margin: 0; }
  .br-modal-close { background: none; border: none; color: ${C.muted}; font-size: 1.25rem; cursor: pointer; padding: 0; line-height: 1; }
  .br-modal-close:hover { color: ${C.text}; }
  .br-field { margin-bottom: 16px; }
  .br-label { display: block; font-size: 0.72rem; font-weight: 700; color: ${C.muted}; margin-bottom: 6px; letter-spacing: 0.04em; text-transform: uppercase; }
  .br-input { width: 100%; padding: 10px 13px; background: rgba(255,255,255,0.04); border: 1.5px solid ${C.border}; border-radius: 10px; font-size: 0.875rem; color: ${C.text}; font-family: inherit; outline: none; box-sizing: border-box; transition: border-color 150ms; }
  .br-input:focus { border-color: ${C.teal}; }
  .br-input::placeholder { color: ${C.muted}; }
  .br-error { background: rgba(255,107,107,0.1); border: 1px solid rgba(255,107,107,0.3); border-radius: 10px; padding: 10px 14px; font-size: 0.82rem; color: ${C.coral}; margin-bottom: 16px; }
  .br-checkbox-row { display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 0.85rem; color: ${C.sub}; }
  .br-modal-footer { display: flex; justify-content: flex-end; gap: 10px; margin-top: 24px; border-top: 1px solid ${C.border}; padding-top: 20px; }
  .br-btn-cancel { padding: 10px 18px; border-radius: 10px; border: 1px solid ${C.border}; background: rgba(255,255,255,0.04); color: ${C.muted}; font-weight: 600; font-size: 0.85rem; cursor: pointer; font-family: inherit; }
  .br-btn-cancel:hover { background: rgba(255,255,255,0.07); color: ${C.text}; }
`;

const API = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
const EMPTY = { name: '', address: '', phone: '', isDefault: false };

export default function Branches() {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState(EMPTY);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [editId, setEditId]     = useState(null);

  const tok = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${tok}` };

  const load = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}/branches`, { headers });
      const data = await r.json();
      if (r.ok) setBranches(Array.isArray(data) ? data : []);
      else setError(data.error || 'Failed to load branches');
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const openAdd = () => {
    setForm(EMPTY);
    setEditId(null);
    setError('');
    setModal('add');
  };

  const openEdit = (branch) => {
    setForm({ name: branch.name, address: branch.address || '', phone: branch.phone || '', isDefault: branch.isDefault, isActive: branch.isActive });
    setEditId(branch.id);
    setError('');
    setModal('edit');
  };

  const closeModal = () => { setModal(null); setError(''); };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { setError('Branch name is required'); return; }
    setSaving(true);
    setError('');
    try {
      const url    = modal === 'edit' ? `${API}/branches/${editId}` : `${API}/branches`;
      const method = modal === 'edit' ? 'PUT' : 'POST';
      const r = await fetch(url, { method, headers, body: JSON.stringify(form) });
      const data = await r.json();
      if (!r.ok) { setError(data.error || 'Save failed'); return; }
      await load();
      closeModal();
    } catch {
      setError('Network error');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (branch) => {
    if (!confirm(`Delete branch "${branch.name}"? Sales and inventory in this branch will be unassigned.`)) return;
    try {
      const r = await fetch(`${API}/branches/${branch.id}`, { method: 'DELETE', headers });
      const data = await r.json();
      if (!r.ok) { alert(data.error || 'Delete failed'); return; }
      await load();
    } catch {
      alert('Network error');
    }
  };

  const handleSetDefault = async (branch) => {
    try {
      const r = await fetch(`${API}/branches/${branch.id}`, {
        method: 'PUT', headers,
        body: JSON.stringify({ isDefault: true }),
      });
      if (r.ok) await load();
    } catch { /* ignore */ }
  };

  return (
    <Layout>
      <style>{STYLES}</style>
      <div className="br-page">
        <div className="br-header">
          <div>
            <h1 className="br-title">Branches</h1>
            <p className="br-sub">Manage physical locations or branches of your business</p>
          </div>
          <button className="br-btn-primary" onClick={openAdd}>+ Add Branch</button>
        </div>

        {loading ? (
          <div className="br-loading">Loading branches...</div>
        ) : branches.length === 0 ? (
          <div className="br-wrap">
            <div className="br-empty">
              <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>🏢</div>
              <h3 style={{ color: C.sub, margin: '0 0 8px', fontSize: '1rem', fontWeight: 700 }}>No branches yet</h3>
              <p style={{ color: C.muted, fontSize: '0.875rem', margin: '0 0 20px' }}>Add your first branch to start tracking sales and inventory by location.</p>
              <button className="br-btn-primary" onClick={openAdd}>+ Add Branch</button>
            </div>
          </div>
        ) : (
          <div className="br-wrap">
            <table className="br-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Default</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {branches.map((b) => (
                  <tr key={b.id}>
                    <td className="br-td"><strong style={{ color: C.text }}>{b.name}</strong></td>
                    <td className="br-td" style={{ color: C.muted }}>{b.address || '—'}</td>
                    <td className="br-td" style={{ color: C.muted }}>{b.phone || '—'}</td>
                    <td className="br-td">
                      <span className={b.isActive ? 'br-badge-active' : 'br-badge-inactive'}>
                        {b.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="br-td">
                      {b.isDefault ? (
                        <span className="br-badge-default">Default</span>
                      ) : (
                        <button className="br-btn-ghost" onClick={() => handleSetDefault(b)}>Set default</button>
                      )}
                    </td>
                    <td className="br-td">
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button className="br-btn-sm" onClick={() => openEdit(b)}>Edit</button>
                        {!b.isDefault && (
                          <button className="br-btn-sm br-btn-danger" onClick={() => handleDelete(b)}>Delete</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && (
        <div className="br-overlay" onClick={closeModal}>
          <div className="br-modal" onClick={(e) => e.stopPropagation()}>
            <div className="br-modal-header">
              <h2 className="br-modal-title">{modal === 'edit' ? 'Edit Branch' : 'Add Branch'}</h2>
              <button className="br-modal-close" onClick={closeModal}>×</button>
            </div>
            <form onSubmit={handleSave}>
              {error && <div className="br-error">{error}</div>}
              <div className="br-field">
                <label className="br-label">Branch Name *</label>
                <input
                  className="br-input"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="e.g. Main Branch, Kumasi, Airport City"
                  required
                />
              </div>
              <div className="br-field">
                <label className="br-label">Address</label>
                <input
                  className="br-input"
                  value={form.address}
                  onChange={(e) => setForm({ ...form, address: e.target.value })}
                  placeholder="Street address"
                />
              </div>
              <div className="br-field">
                <label className="br-label">Phone</label>
                <input
                  className="br-input"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  placeholder="+233..."
                />
              </div>
              <div className="br-field">
                <label className="br-checkbox-row">
                  <input
                    type="checkbox"
                    checked={form.isDefault}
                    onChange={(e) => setForm({ ...form, isDefault: e.target.checked })}
                  />
                  Set as default branch
                </label>
              </div>
              {modal === 'edit' && (
                <div className="br-field">
                  <label className="br-checkbox-row">
                    <input
                      type="checkbox"
                      checked={form.isActive}
                      onChange={(e) => setForm({ ...form, isActive: e.target.checked })}
                    />
                    Active
                  </label>
                </div>
              )}
              <div className="br-modal-footer">
                <button type="button" className="br-btn-cancel" onClick={closeModal}>Cancel</button>
                <button type="submit" className="br-btn-primary" disabled={saving}>
                  {saving ? 'Saving...' : modal === 'edit' ? 'Save Changes' : 'Create Branch'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
